import { Col, CollapseProps, Row, theme } from "antd";
import React, { ReactNode } from "react";

import { ESAccordion } from "./ESAccordion";
import { AccordionContent, AccordionLabel } from "./styled";
import { ESAccordionGroupProps } from "./types";

import { keywordLinkRawHtml } from "~/Applet/KeywordLinker/utils";
import { useKeywords } from "~/hooks/useKeywords";

export const ESAccordionGroup: React.FC<
  ESAccordionGroupProps<Record<string, ReactNode>>
> = ({
  itemsArray,
  labelKey,
  contentKey,
  columns = 1,
  keywordLinkHrefTypes,
}) => {
  const { token } = theme.useToken();

  const keywords = useKeywords();

  if (!itemsArray?.length) {
    return null;
  }

  const items: CollapseProps["items"] = itemsArray.map((item, index) => {
    const labelValue = item[labelKey];
    const contentValue = item[contentKey];

    return {
      key: index,
      label: <AccordionLabel $token={token}>{labelValue}</AccordionLabel>,
      children:
        typeof contentValue === "string" ? (
          <AccordionContent
            $token={token}
            dangerouslySetInnerHTML={{
              __html: (keywords && keywordLinkHrefTypes
                ? keywordLinkRawHtml(
                    contentValue,
                    keywordLinkHrefTypes,
                    keywords
                  )
                : contentValue) as TrustedHTML,
            }}
          />
        ) : (
          <AccordionContent $token={token}> {contentValue} </AccordionContent>
        ),
    };
  });

  return (
    <Row gutter={32}>
      {items.map((item) => (
        <Col
          //style={{ width: "100%" }}
          xs={24}
          md={columns > 1 ? 12 : 24}
          key={`item-${item.key}`}
        >
          <ESAccordion
            items={[item]}
            defaultActiveKey={
              columns === undefined || columns === 1 ? ["0"] : undefined
            }
          />
        </Col>
      ))}
    </Row>
  );
};
